<template>
  <div class="favourites h-screen flex flex-col">
    <base-dialog
      :show="!!makeBooking"
      title="Make a booking"
      @close="handleBooking"
      theme="grey"
      fixed
    >
      <form-booking theme="light" @close="showSentDialog"></form-booking>
    </base-dialog>
    <base-dialog
      :show="!!sendBooking"
      title="Booking Sent!"
      @close="handleSendBooking"
      fixed
    >
    </base-dialog>
    <base-dialog
      :show="!!showShare"
      title="Share"
      @close="handleShare"
      fixed
    >
      <div class="flex">
        <button
          v-if="$mq === 'sm'"
          title="Share via WeChat"
          class="flex-grow"
        >
          <img
            class="img"
            src="data:image/svg+xml;base64,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"
          />
          <p>WeChat</p>
        </button>
        <button
          v-if="$mq === 'sm'"
          title="Share via WhatsApp"
          class="flex-grow"
        >
          <img
            class="img"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDY4MiA2ODIuNjY2NjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZD0ibTU0NC4zODY3MTkgOTMuMDA3ODEyYy01OS44NzUtNTkuOTQ1MzEyLTEzOS41MDM5MDctOTIuOTcyNjU1OC0yMjQuMzM1OTM4LTkzLjAwNzgxMi0xNzQuODA0Njg3IDAtMzE3LjA3MDMxMiAxNDIuMjYxNzE5LTMxNy4xNDA2MjUgMzE3LjExMzI4MS0uMDIzNDM3IDU1Ljg5NDUzMSAxNC41NzgxMjUgMTEwLjQ1NzAzMSA0Mi4zMzIwMzIgMTU4LjU1MDc4MWwtNDQuOTkyMTg4IDE2NC4zMzU5MzggMTY4LjEyMTA5NC00NC4xMDE1NjJjNDYuMzI0MjE4IDI1LjI2OTUzMSA5OC40NzY1NjIgMzguNTg1OTM3IDE1MS41NTA3ODEgMzguNjAxNTYyaC4xMzI4MTNjMTc0Ljc4NTE1NiAwIDMxNy4wNjY0MDYtMTQyLjI3MzQzOCAzMTcuMTMyODEyLTMxNy4xMzI4MTIuMDM1MTU2LTg0Ljc0MjE4OC0zMi45MjE4NzUtMTY0LjQxNzk2OS05Mi44MDA3ODEtMjI0LjM1OTM3NnptLTIyNC4zMzU5MzggNDg3LjkzMzU5NGgtLjEwOTM3NWMtNDcuMjk2ODc1LS4wMTk1MzEtOTMuNjgzNTk0LTEyLjczMDQ2OC0xMzQuMTYwMTU2LTM2Ljc0MjE4N2wtOS42MjEwOTQtNS43MTQ4NDQtOTkuNzY1NjI1IDI2LjE3MTg3NSAyNi42Mjg5MDctOTcuMjY5NTMxLTYuMjY5NTMyLTkuOTcyNjU3Yy0yNi4zODY3MTgtNDEuOTY4NzUtNDAuMzIwMzEyLTkwLjQ3NjU2Mi00MC4yOTY4NzUtMTQwLjI4MTI1LjA1NDY4OC0xNDUuMzMyMDMxIDExOC4zMDQ2ODgtMjYzLjU3MDMxMiAyNjMuNjk5MjE5LTI2My41NzAzMTIgNzAuNDA2MjUuMDIzNDM4IDEzNi41ODk4NDQgMjcuNDc2NTYyIDE4Ni4zNTU0NjkgNzcuMzAwNzgxczc3LjE1NjI1IDExNi4wNTA3ODEgNzcuMTMyODEyIDE4Ni40ODQzNzVjLS4wNjI1IDE0NS4zNDM3NS0xMTguMzA0Njg3IDI2My41OTM3NS0yNjMuNTkzNzUgMjYzLjU5Mzc1em0xNDQuNTg1OTM4LTE5Ny40MTc5NjhjLTcuOTIxODc1LTMuOTY4NzUtNDYuODgyODEzLTIzLjEzMjgxMy01NC4xNDg0MzgtMjUuNzgxMjUtNy4yNTc4MTItMi42NDQ1MzItMTIuNTQ2ODc1LTMuOTYwOTM4LTE3LjgyNDIxOSAzLjk2ODc1LTUuMjg1MTU2IDcuOTI5Njg3LTIwLjQ2ODc1IDI1Ljc4MTI1LTI1LjA5Mzc1IDMxLjA2NjQwNi00LjYyNSA1LjI4OTA2Mi05LjI0MjE4NyA1Ljk1MzEyNS0xNy4xNjc5NjggMS45ODQzNzUtNy45MjU3ODItMy45NjQ4NDQtMzMuNDU3MDMyLTEyLjMzNTkzOC02My43MjY1NjMtMzkuMzMyMDMxLTIzLjU1NDY4Ny0yMS4wMTE3MTktMzkuNDU3MDMxLTQ2Ljk2MDkzOC00NC4wODIwMzEtNTQuODkwNjI2LTQuNjE3MTg4LTcuOTM3NS0uMDM5MDYyLTExLjgxMjUgMy40NzY1NjItMTYuMTcxODc0IDguNTc4MTI2LTEwLjY1MjM0NCAxNy4xNjc5NjktMjEuODIwMzEzIDE5LjgwODU5NC0yNy4xMDU0NjkgMi42NDQ1MzItNS4yODkwNjMgMS4zMjAzMTMtOS45MTc5NjktLjY2NDA2Mi0xMy44ODI4MTMtMS45NzY1NjMtMy45NjQ4NDQtMTcuODI0MjE5LTQyLjk2ODc1LTI0LjQyNTc4Mi01OC44Mzk4NDQtNi40Mzc1LTE1LjQ0NTMxMi0xMi45NjQ4NDMtMTMuMzU5Mzc0LTE3LjgzMjAzMS0xMy42MDE1NjItNC42MTcxODctLjIzMDQ2OS05LjkwMjM0My0uMjc3MzQ0LTE1LjE4NzUtLjI3NzM0NC01LjI4MTI1IDAtMTMuODY3MTg3IDEuOTgwNDY5LTIxLjEzMjgxMiA5LjkxNzk2OS03LjI2MTcxOSA3LjkzMzU5NC0yNy43MzA0NjkgMjcuMTAxNTYzLTI3LjczMDQ2OSA2Ni4xMDU0NjlzMjguMzk0NTMxIDc2LjY4MzU5NCAzMi4zNTU0NjkgODEuOTcyNjU2YzMuOTYwOTM3IDUuMjg5MDYyIDU1Ljg3ODkwNiA4NS4zMjgxMjUgMTM1LjM2NzE4NyAxMTkuNjQ4NDM4IDE4LjkwNjI1IDguMTcxODc0IDMzLjY2NDA2MyAxMy4wNDI5NjggNDUuMTc1NzgyIDE2LjY5NTMxMiAxOC45ODQzNzQgNi4wMzEyNSAzNi4yNTM5MDYgNS4xNzk2ODggNDkuOTEwMTU2IDMuMTQwNjI1IDE1LjIyNjU2Mi0yLjI3NzM0NCA0Ni44Nzg5MDYtMTkuMTcxODc1IDUzLjQ4ODI4MS0zNy42Nzk2ODcgNi42MDE1NjMtMTguNTExNzE5IDYuNjAxNTYzLTM0LjM3NSA0LjYxNzE4Ny0zNy42ODM1OTQtMS45NzY1NjItMy4zMDQ2ODgtNy4yNjE3MTgtNS4yODUxNTYtMTUuMTgzNTkzLTkuMjUzOTA2em0wIDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzAwMDAwMCIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgc3R5bGU9IiIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
          />
          <p>WhatsApp</p>
        </button>
        <button title="Share via Email" class="flex-grow">
          <img
            class="img"
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDFMMTAgMTIiIHN0cm9rZT0iIzJEMjkyNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDFMMTQgMjFMMTAgMTJMMSA4TDIxIDFaIiBzdHJva2U9IiMyRDI5MjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
          />
          <p>Email</p>
        </button>
      </div>
    </base-dialog>
    <the-header></the-header>
    <base-content class="flex-grow">
      <base-page-heading
        title="Favourites"
      ></base-page-heading>
      <div class="text-center">
        <base-button width="width-auto" @click="clearFavourites">Reset</base-button>
        <base-button width="width-auto" class="mx-1" @click="handleShare">Share</base-button>
        <base-button width="width-auto mt-1 md:mt-0" @click="handleBooking">Make a booking</base-button>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2">
        <div class="cursor-pointer" v-for="favourite in favourites" :key="favourite.id" @click="showFavourite(favourite.id)">
          <img :src="favourite.img">
          <h3 class="text-2xl">{{ favourite.name }}, {{ favourite.type }}</h3>
        </div>
      </div>
    </base-content>
    <the-footer></the-footer>
  </div>
</template>

<script>
import FormBooking from "../components/forms/FormBooking.vue";

export default {
  name: 'Favourites',
  components: {
    FormBooking,
  },
  data() {
    return {
      makeBooking: false,
      sendBooking: false,
      showShare: false
    }
  },
  computed: {
    favourites() {
      const favourites = this.$store.getters["units/favourites"];
      const images = this.$store.getters["categories/images"];
      const floorplans = [];
      favourites.forEach(function(u, index) {
        const unit = u[Object.keys(u)[0]];
        const type = images[unit.property_type.name];
        const floorplan = {
          id: unit.id,
          name: unit.name,
          type: unit.property_type.name,
          img: type.medium,
          idx: index
        }
        floorplans.push(floorplan);
      })
      return floorplans;
    }
  },
  beforeCreate: function() {
    document.body.className = "bg-white";
  },
  methods: {
    showFavourite(id) {
      const units = this.$store.getters["units/units"];
      const unit = units[id];
      this.$store.dispatch("units/setUnit", unit);
      this.$router.push('/finder');
    },
    clearFavourites() {
      this.$store.dispatch("units/clearFavourites");
    },
    handleBooking() {
      this.makeBooking = !this.makeBooking;
    },
    showSentDialog() {
      this.handleBooking();
      this.sendBooking = true;
    },
    handleSendBooking() {
      this.sendBooking = false;
    },
    handleShare() {
      this.showShare = !this.showShare;
    }
  }
}
</script>

<style scoped>
.img {
  height: 60px;
  display: inline-block;
}
</style>